import RosterBase from './Roster.vue'
import ConstList from './../ConstList'

const hasTimeValue = value => value !== null && value !== undefined && String(value) !== ''

/**
 * 勤務表の実績休憩を自動候補より優先するラッパー。
 *
 * 定時直後休憩は会社設定から初期値として反映するが、電話対応・待機・作業等が
 * あった日に利用者が休憩欄を実績へ直した後は、終了時刻やプロジェクト基準の
 * 再取得で上書きしない。管理者用勤務表も同じコンポーネントを使う。
 */
export default {
  name: 'Roster',
  extends: RosterBase,

  data () {
    return {
      manualRestOverrides: []
    }
  },

  watch: {
    // 保存済みの日次休憩は実績値として扱う。読込完了後にだけ固定することで、
    // 新規行の自動候補は引き続き開始・終了変更に追随できる。
    loading (value) {
      if (!value && this.displayFlg) {
        this.markPersistedRestOverrides()
      }
    }
  },

  methods: {
    setManualRestOverride (index, value) {
      if (!Number.isInteger(index) || index < 0) return
      this.$set(this.manualRestOverrides, index, Boolean(value))
    },

    markPersistedRestOverrides () {
      const rowIds = Array.isArray(this.id) ? this.id : []
      rowIds.forEach((rowId, index) => {
        this.$set(
          this.manualRestOverrides,
          index,
          rowId != null && hasTimeValue(this.rest[index])
        )
      })
    },

    onUpdateRest ({ index, value }) {
      RosterBase.methods.onUpdateRest.call(this, { index, value })
      this.setManualRestOverride(index, true)
    },

    autoRestTime (index, options = {}) {
      const force = Boolean(options && options.force)

      // 勤務時刻自体を消した場合は、休憩だけを残さない。
      if (!this.start[index] || !this.end[index]) {
        this.setManualRestOverride(index, false)
        RosterBase.methods.autoRestTime.call(this, index)
        return true
      }

      // 手動で実績へ修正した休憩は、定時・案件基準の再取得で上書きしない。
      if (!force && this.manualRestOverrides[index]) {
        return false
      }

      RosterBase.methods.autoRestTime.call(this, index)
      return true
    },

    applyDefaultAt (index) {
      // 「定時を反映」は利用者が明示した再計算操作なので、自動候補へ戻す。
      this.setManualRestOverride(index, false)
      return RosterBase.methods.applyDefaultAt.call(this, index)
    },

    autoTime (index) {
      const attendance = this.attendance1[index]
      if (
        attendance === ConstList.PAID ||
        attendance === ConstList.SUBSTITUTE ||
        attendance === ConstList.SPECIAL_HOLIDAY ||
        attendance === ConstList.DEDUCTION ||
        attendance === ConstList.HOLIDAY
      ) {
        this.setManualRestOverride(index, false)
      }
      return RosterBase.methods.autoTime.call(this, index)
    },

    applyRosterFileImport (payload) {
      const before = Array.isArray(this.rest) ? this.rest.slice() : []
      const result = RosterBase.methods.applyRosterFileImport.call(this, payload)

      // ファイルへ明示された休憩は実績入力として扱う。スケジュールからの
      // 自動補完はロックせず、その後の時刻変更へ追随させる。
      this.$nextTick(() => {
        ;((payload && payload.rows) || []).forEach(row => {
          if (!row || !Number.isInteger(row.index)) return
          const values = row.values || {}
          if (!Object.prototype.hasOwnProperty.call(values, 'rest')) return
          const after = this.rest[row.index]
          if (String(before[row.index] ?? '') !== String(after ?? '')) {
            this.setManualRestOverride(row.index, true)
          }
        })
      })
      return result
    }
  }
}
